<template>
    <div className="form-group" :class="{ focused: props.defaultValue != null }">
        <label htmlFor="phone_number" className="d-none">{{ props.label }}</label>
        <input id="phone_number" v-model="phone_number" maxLength="30" type="tel" @blur="onBlur" @focus="onFocus"
            :class="{ 'error': props.valid.$errors.length }" />
        <span v-if="props.valid.$errors.length" className="error-message">
            {{ props.valid.$errors[0].$message }}
        </span>
    </div>
</template>

<script setup>
import { nextTick, ref, watch } from 'vue'
import { onBlur, onFocus } from './fields.js'
import intlTelInput from 'intl-tel-input'
import 'intl-tel-input/build/css/intlTelInput.css'

const props = defineProps({
    label: String,
    valid: Object,
    defaultValue: String
})

const emit = defineEmits(['change', 'valid'])
const phone_number = ref(props?.defaultValue)

if (props?.defaultValue) {
    emit('change', props?.defaultValue)
    emit('valid', true)
}

const country = window.countryCode

let iti = null

watch(phone_number, async (newQuestion, oldQuestion) => {
    if (iti.isValidNumber()) {
        emit('valid', true);
        emit('change', iti.getNumber(intlTelInputUtils.numberFormat.E164));
    } else {
        emit('valid', false)
    }
})

nextTick(() => {
    const input = document.querySelector('#phone_number')
    iti = intlTelInput(input, {
        utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.js',
        initialCountry: country,
        customContainer: 'phone-dropdown',
        allowDropdown: true,
        formatOnDisplay: true,
        separateDialCode: true,
        autoFormat: true,
        autoPlaceholder: 'aggressive'
    })
})
</script>

<style>
.phone-dropdown {
    width: 100% !important;
}

.phone-dropdown .form-style .form-item label {
    left: 80px;
}

.phone-dropdown .form-style .form-item input:focus~.phone-dropdown label {
    opacity: 1;
}

.show-label {
    opacity: 1 !important;
    left: 75px !important;
    top: 2px !important;
}

.iti__arrow {
    margin-left: 6px;
    width: 0;
    height: 0;
    border-left: 3px solid transparent;
    border-right: 3px solid transparent;
    border-top: 4px solid #555;
    margin-right: 3px;
}

#phone::placeholder {
    color: #9b9b9b;
}
</style>
